var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50009 14.4001C12.0347 14.4001 14.9001 11.5347 14.9001 8.0001C14.9001 4.46548 12.0347 1.6001 8.50009 1.6001C4.96547 1.6001 2.1001 4.46548 2.1001 8.0001C2.1001 11.5347 4.96547 14.4001 8.50009 14.4001ZM9.30009 5.6001C9.30009 5.15827 8.94192 4.8001 8.50009 4.8001C8.05827 4.8001 7.70009 5.15827 7.70009 5.6001V7.2001H6.10009C5.65827 7.2001 5.3001 7.55827 5.3001 8.0001C5.3001 8.44192 5.65827 8.8001 6.10009 8.8001H7.70009V10.4001C7.70009 10.8419 8.05827 11.2001 8.50009 11.2001C8.94192 11.2001 9.30009 10.8419 9.30009 10.4001V8.8001H10.9001C11.3419 8.8001 11.7001 8.44192 11.7001 8.0001C11.7001 7.55827 11.3419 7.2001 10.9001 7.2001H9.30009V5.6001Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircle);
export default __webpack_public_path__ + "static/media/Plus circle.68c605f025f2c21fa34b80455d0d40cb.svg";
export { ForwardRef as ReactComponent };